module.exports = __webpack_public_path__ + "img/TJ.ab3bac64.svg";